'use client'

import { ApolloProvider as ApolloLegacyProvider } from '@apollo/client'
import { createApolloClient } from '@/services/apollo-client'

const ApolloProvider = ({ children, locale = 'es_AR', data }) => {
  const apolloClient = createApolloClient(locale)

  return (
    <ApolloLegacyProvider client={apolloClient}>
      {children}
    </ApolloLegacyProvider>
  )
}

export default ApolloProvider
